<template>
  <div>
    <table class="ui compact celled definition table">
      <thead class="full-width">
        <tr>
          <th></th>
          <th>{{ $t("module") }}</th>
          <!-- <th>Premium Plan</th> -->
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(mdule, index) in modules"
          :key="index"
          v-bind:class="{
            hidden:
              (hide_unused &&
                (!mdule.usr_module_suscriptions ||
                  !mdule.usr_module_suscriptions.length)) ||
              mdule.setup.parent_modules,
          }"
        >
          <td class="collapsing">
            <div class="ui fitted toggle checkbox">
              <input
                type="checkbox"
                checked
                v-if="
                  mdule.usr_module_suscriptions &&
                    mdule.usr_module_suscriptions.length
                "
              />
              <label></label>
            </div>
          </td>
          <td>
            <div class="ui horizontal list">
              <div class="item">
                <img
                  class="ui mini circular image"
                  :src="mdule.setup.image || '/images/icons/generic_module.png'"
                />
                <div class="content">
                  <div class="ui sub header">{{ $t(mdule.setup.name) }}</div>
                  {{ mdule.setup.description }}
                </div>
              </div>
            </div>
            <!-- <h2 class="ui header">
              <img :src="mdule.setup.image" />
              <div class="content">
                {{ $t(mdule.setup.name) }}
                <div class="sub header">{{ $t(mdule.setup.name) }}</div>
              </div>
            </h2> -->
          </td>
          <!-- <td>
            <pre>{{ mdule }}</pre>
          </td> -->
        </tr>
      </tbody>
      <!-- <tfoot class="full-width">
        <tr>
          <th></th>
          <th colspan="4">
            <div class="ui right floated small primary labeled icon button">
              <i class="user icon"></i> Add User
            </div>
            <div class="ui small  button">
              Approve
            </div>
            <div class="ui small  disabled button">
              Approve All
            </div>
          </th>
        </tr>
      </tfoot> -->
    </table>
  </div>
</template>

<script>
export default {
  name: "SettingsModuleManagementTableView",
  props: {
    modules: { type: Array },
    hide_unused: { type: Boolean },
  },
  data() {
    return {};
  },
};
</script>
